import React from 'react';
import PropTypes from 'prop-types';

const NumberInput = ({ inputValue, onChange, onKeyPress, label }) => {
    const inputId = `${label.toLowerCase().replace(/\s+/g, '-')}-number-input`;
    return (
        <div className="filter-item">
            <label htmlFor={inputId}>{label}:</label>
            <div>
                <input
                    className="number-input"
                    type="number"
                    id={inputId}
                    value={inputValue}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    min={0}
                    step={1}
                    aria-label={`${label} input`}
                    aria-describedby={`${inputId}-description`}
                />
                <span id={`${inputId}-description`} className="sr-only">
                    Enter a number value for {label}
                </span>
            </div>
        </div>
    );
};

NumberInput.propTypes = {
    inputValue: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default NumberInput;
